// extracted by mini-css-extract-plugin
export default {"container":"ChartDetails_container__Agleh","header":"ChartDetails_header__p+nOs","amount":"ChartDetails_amount__L-FCn","date":"ChartDetails_date__RyP+A"};